export const PRETIREMENT_USER = window.APP?.CONFIG?.TOKEN_NAME || 'pretirement-user'
export const PRETIREMENT_FAVORITED_ACTIONS = 'pretirement-favorited-actions'
export const PRETIREMENT_QUIZ_CALLOUT = 'pretirement-quiz-callout'
